// routes
import { PATH_AUTH, PATH_DOCS, PATH_PAGE } from '../../routes/paths';
// components
import { PATH_AFTER_LOGIN } from '../../config';
// components
import Iconify from '../../components/Iconify';
import SvgIconStyle from "../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title: 'Home',
    icon: <Iconify icon={'eva:home-fill'} {...ICON_SIZE} />,
    path: '/',
  },
  {
    title: 'Pesquisa de Empresas',
    icon: <Iconify icon={'eva:search-fill'} {...ICON_SIZE} />,
    path: PATH_PAGE.companies.root,
  },
  {
    title: 'Entrar',
    icon: <SvgIconStyle src={`/icons/ic_dashboard.svg`} {...ICON_SIZE} />,
    path: PATH_AFTER_LOGIN,
  },
];

export default menuConfig;
